import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default () => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">Payments</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y where, <br />
          X = Total payment amount for selected month/quarter <br />Y = Total
          payment amount for previous month/quarter
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
